/************* LEAD TIME *************/
window.getLeadTime = () => {
  const leadTimeJson = document.getElementById('lead_time_settings') ? JSON.parse(document.getElementById('lead_time_settings').textContent) : null;

  if (!leadTimeJson || leadTimeJson.enable_lead_time === false) return null;

  const shippingDays = parseInt(leadTimeJson.express_shipping_method) || 0;
  const leadTimeDays = parseInt(leadTimeJson.lead_time) || 0;
  const holidayDates = leadTimeJson.holiday_dates ? leadTimeJson.holiday_dates.map(dateStr => new Date(dateStr.replace("\n", "").trim())) : [];
  const totalDays = shippingDays + leadTimeDays;

  // Get current time in EST timezone
  const currentDate = new Date();
  const estTimeString = currentDate.toLocaleString('en-US', { timeZone: 'America/New_York' });
  const estDate = new Date(estTimeString);
  const startDate = new Date(estDate); // Save start date for comparison
  const currentHour = estDate.getHours();

  const isHoliday = (date) => {
    return holidayDates.some(holiday => {
      return holiday.getFullYear() === date.getFullYear() && holiday.getMonth() === date.getMonth() && holiday.getDate() === date.getDate();
    });
  };

  const isNonWorkingDay = (date) => {
    const day = date.getDay();
    return day === 0 || day === 6 || isHoliday(date);
  };

  // If before 9:00 AM EST and not a weekend/holiday, reduce one day
  let adjustedTotalDays = totalDays;
  if (currentHour < 7 && !isNonWorkingDay(estDate) && totalDays > 0) {
    adjustedTotalDays = totalDays - 1;
  }

  // Skip non-working days for order placement
  while (isNonWorkingDay(estDate)) {
    estDate.setDate(estDate.getDate() + 1);
  }

  // Add all days including weekends and holidays
  for (let i = 0; i < adjustedTotalDays; i++) {
    estDate.setDate(estDate.getDate() + 1);
    
    // If we hit a weekend or holiday, add extra day
    while (isNonWorkingDay(estDate)) {
      estDate.setDate(estDate.getDate() + 1);
    }
  }

  // Calculate days difference
  const daysDiff = Math.ceil((estDate - startDate) / (1000 * 60 * 60 * 24));

  // If more than 7 days, show date instead of day name
  if (daysDiff > 7) {
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const month = months[estDate.getMonth()];
    const day = estDate.getDate();
    return `Get it by ${month} ${day}`;
  }

  const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  const deliveryDay = daysOfWeek[estDate.getDay()];

  return `Get it by ${deliveryDay}`;
}

window.addLeadTimeToCards = () => {
  const productCardsLeadTime = document.querySelectorAll('.lead-time-value');
  const leadTime = getLeadTime();

  if (!leadTime) return;

  productCardsLeadTime.forEach((leadTimeElement) => {
    leadTimeElement.textContent = leadTime;
  });
};
/************* END LEAD TIME *************/